import { useRef, useState } from 'react';

import Footer from 'src/ui-bloom/components/Footer';
import PageHeader from './PageHeader';

import { Grid } from '@mui/material';
import PageTitleWrapper from 'src/ui-bloom/components/PageTitleWrapper';

import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import ErrorPanel from 'src/components/error-panel';
import { QKEY, getEventBookings } from 'src/services/query-client';
import Results from './Results';

function BookingsList() {
  const { enqueueSnackbar } = useSnackbar();
  const [isExportClicked, setIsExportClicked] = useState(false);
  const [teamDataRefreshTriggerId, setTeamDataRefreshTriggerId] = useState('');
  const refLink = useRef(null);
  const { id: eventId } = useParams();
  const {
    data: { data: bookings = [] } = {},
    isError,
    error,
    isLoading,
    refetch
  } = useQuery([QKEY.EventBookings, eventId], () => getEventBookings(eventId), {
    enabled: !!eventId
  });

  const onRefreshData = () => {
    setTeamDataRefreshTriggerId(Date.now() + '');
  };

  return (
    <>
      <PageTitleWrapper>
        <PageHeader refreshData={onRefreshData} />
      </PageTitleWrapper>

      <Grid
        sx={{
          px: 4
        }}
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={4}
      >
        <Grid item xs={12}>
          {isError && (
            <ErrorPanel
              title="failed to load data"
              message={JSON.stringify(error)}
            />
          )}
        </Grid>

        <Grid item xs={12}>
          <Results
            bookings={bookings}
            isLoading={isLoading}
            onDeleteSuccess={() => refetch()}
          />
        </Grid>
      </Grid>
      <Footer />
    </>
  );
}

export default BookingsList;
